export function SafeCryptoLogo({ size = 36, className = '' }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <defs>
        <linearGradient id="blueGrad" x1="0" y1="0" x2="50" y2="100" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stopColor="#00A3FF" />
          <stop offset="100%" stopColor="#001F5A" />
        </linearGradient>
        <linearGradient id="greenGrad" x1="50" y1="0" x2="100" y2="100" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stopColor="#50F2A6" />
          <stop offset="100%" stopColor="#00BF9A" />
        </linearGradient>
      </defs>
      {/* Left half of shield */}
      <path
        d="M50 5 L12 20 L12 55 C12 72 28 88 50 95 L50 5Z"
        fill="url(#blueGrad)"
      />
      {/* Right half of shield */}
      <path
        d="M50 5 L88 20 L88 55 C88 72 72 88 50 95 L50 5Z"
        fill="url(#greenGrad)"
      />
      {/* Letter S */}
      <path
        d="M58 30 C58 30 54 26 47 26 C40 26 34 30 34 37 C34 44 40 47 47 49 C54 51 58 53 58 58 C58 63 54 68 47 68 C40 68 36 64 36 64"
        stroke="white"
        strokeWidth="7"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  );
}
